export const initialFilter = {
  filter: {
    name: "",
  },
  search: "",
  sortOrder: "desc", // asc||desc
  sortField: "date",
  pageNumber: 1,
  pageSize: 10,
};
